import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgCommentConsole = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.5H2C1.175 0.5 0.5 1.175 0.5 2V15.5L3.5 12.5H14C14.825 12.5 15.5 11.825 15.5 11V2C15.5 1.175 14.825 0.5 14 0.5ZM14 11H3.5L2 12.5V2H14V11Z"
      fill="#D0BCFF"
    />
  </svg>
);

export default SvgCommentConsole;
